import React from 'react';
import { Link } from 'react-router-dom';
import StructureImage from './StructureImage';
import { moleculeWorkbenchLink } from '../../utils/workbenchNavigation';

export interface ProteinLigand {
  molecule_id: number;
  smiles: string | null;
  file_id: number | null;
  name?: string | null;
  reference_id?: string | null;
  file_name?: string | null;
  binding_site?: string | null;
  interaction_type: string;
  affinity_value: number | null;
  affinity_unit: string | null;
}

export default function ProteinLigandCard({ ligand }: { ligand: ProteinLigand }) {
  const name = ligand.name?.trim() || `Molecule #${ligand.molecule_id}`;
  const href = moleculeWorkbenchLink(ligand.file_id, ligand.molecule_id);
  const structure = <StructureImage moleculeId={ligand.molecule_id} smiles={ligand.smiles || undefined} size={160} />;
  return (
    <div className="p-4 flex flex-wrap items-start gap-4 hover:bg-gray-50">
      {href ? (
        <Link to={href} aria-label={`Open ${name} compound record`} title={`Open ${name} and highlight its chemical record`}
          className="block rounded-lg border bg-white p-2 hover:border-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-600">
          {structure}
        </Link>
      ) : <div className="rounded-lg border bg-white p-2">{structure}</div>}
      <div className="flex-1 min-w-[180px]">
        <h4 className="font-semibold text-gray-900">{name}</h4>
        <div className="text-xs text-gray-500 mt-1">
          {ligand.reference_id ? `${ligand.reference_id} · ` : ''}Molecule #{ligand.molecule_id}
        </div>
        <div className="flex flex-wrap items-center gap-2 mt-3">
          <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded text-xs font-medium">
            {ligand.interaction_type.replace(/_/g, ' ')}
          </span>
          {ligand.affinity_value != null && <span className="text-sm text-gray-700">{ligand.affinity_value} {ligand.affinity_unit}</span>}
        </div>
        {ligand.binding_site && <p className="text-sm text-gray-600 mt-2">{ligand.binding_site}</p>}
        {ligand.file_name && <p className="text-xs text-gray-500 mt-3 break-all">Source: {ligand.file_name}</p>}
        {href && <p className="text-xs text-gray-500 mt-2">Click the structure to open the linked compound record.</p>}
        {href ? <Link to={href} className="inline-block text-sm font-medium text-teal-700 hover:underline mt-2">Open highlighted compound →</Link>
          : <p className="text-xs text-gray-500 mt-2">Source file unavailable</p>}
      </div>
    </div>
  );
}
